// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__27T6_","ranges":"BmiRanges_ranges__2Pgln"};